export const NATURAL_LANGUAGE_SEARCH_AI_GLOW_EFFECT_TIME_OUT_MS = 4000

export const MIN_VALID_OFFERS_TO_SHOW_RESULTS = 1
export const MIN_INVALID_OFFERS_TO_SHOW_NO_MATCHES = 3
